var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnviarSolicitud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.669,
    height: 91.669,
    viewBox: "0 0 91.669 91.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93",
    transform: "translate(-11208.538 -2367.326)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    width: 91.669,
    height: 91.669,
    transform: "translate(11300.207 2458.995) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "enviar_solicitud",
    "data-name": "enviar solicitud",
    transform: "translate(11217.949 2437.396)",
    fontSize: 20.107,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enviar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.955
  }, "solicitud")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M11219.114,2377h11.166v11.166",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1",
    "data-name": "L\\xEDnea 1",
    y1: 11.056,
    x2: 11.056,
    transform: "translate(11219.225 2377.002)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviarSolicitud);
export default __webpack_public_path__ + "static/media/enviarSolicitud.d6ab3454c8009e1487296c02a6fc4e83.svg";
export { ForwardRef as ReactComponent };